import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const DistributorEmptyMessage = ({ address }) => {
  const { t } = useTranslation()
  if (address && address.trim()) {
    const template = t('subscriptionForm:distributor.empty_text_with_address')
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: (template ?? '').replace('%address%', `<i>${address}</i>`),
        }}
      />
    )
  }
  return <span>{t('subscriptionForm:distributor.empty_text_without_address')}</span>
}

DistributorEmptyMessage.propTypes = {
  address: PropTypes.string,
}

export default DistributorEmptyMessage
